export default __webpack_public_path__ + "static/media/smart-home.ded00b97.png";